<template>
    <div>
        <h1 class="big-title">CrazyTrip</h1>
        <blockquote class="blockquote text-xs-center text-white " >
            You love maps ? <br>
            You love traveling ? <br>
            You want to share your experiences ?<br>
        </blockquote>
<br>
        <b-container>
            <b-row>
                <b-col xs="4">
                    <div v-if="isAuthenticated">
                        <h3 class="text-white">Welcome back {{ currentUser.displayName}}</h3>


                        <b-button variant="success"  @click="$router.push('/explore')">
                            <i class="fa fa-home"/>Continue to the site ....
                        </b-button>


                    </div>

                    <div v-if="!isAuthenticated">
                        <p>


                            <b-button variant="danger"  @click="userSignInWithGoogle">
                                <i class="fa fa-google"/>&nbsp;&nbsp;Login with Google
                            </b-button>

                            <b-button variant="primary"  @click="userSignInWithFacebook">
                                <i class="fa fa-facebook"/>&nbsp;&nbsp;Login with Facebook
                            </b-button>
                        </p>

                        <p class="text-muted fs-sm text-white">
                            Or Be Classical
                        </p>

                        <b-button variant="info"  @click="$router.push('/login')">
                            <i class="fa fa-check"/> Sign in
                        </b-button>

                        <b-button variant="info"  @click="$router.push('/register')">
                            <i class="fa fa-home"/> Register
                        </b-button>

                    </div>
                </b-col>

            </b-row>
        </b-container>


        <!--<v-flex xs12 sm6 offset-sm3 mt-3 v-if=isAuthenticated>-->
        <!--<div>-->
        <!--<h1> Helllooooo-->
        <!--<img :src="currentUser.photoURL" alt="avatar" style="width: 30px; height: 30px; border-radius: 50%;"> {{this.userProfile.fullName}} !!!!!-->
        <!--</h1>-->
        <!--<br>-->
        <!--<button @click="userSignOut">Sign Out</button>-->
        <!--</div>-->
        <!--</v-flex>-->


        <!--<v-flex v-if=!isAuthenticated class="signin-signup-fixed-bottom">-->
        <!--<v-btn color="primary" type="submit" @click="userSignIn" :disabled="loading">-->
        <!--<i class="fa fa-sign-in"></i>Sign in with Google-->
        <!--</v-btn>-->

        <!--<vs-divider>-->
        <!--Or-->
        <!--</vs-divider>-->
        <!--<v-btn color="success" type="submit" @click="$router.push('/signin')" :disabled="loading">-->
        <!--<i class="fa fa-sign-in"></i>Sign in-->
        <!--</v-btn>-->
        <!--<v-btn color="success" type="submit" @click="$router.push('/signup')" :disabled="loading">-->
        <!--<i class="fa fa-sign-in"></i>Sign up-->
        <!--</v-btn>-->
        <!--</v-flex>-->
    </div>

</template>

<style scoped>
    .text-white
    {
        color:#fff;
    }
    .signin-signup-fixed-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 20px;
        background-color: #f2f2f2;
        border-top: 1px solid #3783fe2b;
        width: 100%

    }

    .big-title {
        font-size: 80px;
        font-weight: 100;
        color: white
    }

</style>

<script>

  const fb = require('@/firebaseConfig.js')
  import { mapState } from 'vuex'
  import firebase from 'firebase'
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  export default {
    mixins:
      [
        UIHelpersMixins,
      ],
    data ()
    {
      return {
        alert:          '',
        defaultOptions: {},
        animationSpeed: 1
      }
    },

    components: {
    },

    methods:  {
      userSignIn ()
      {
        this.$store.dispatch('userSignIn', {})
      },
      userSignOut ()
      {
        this.$store.dispatch('userSignOut', {})
      },
      userSignInWithGoogle ()
      {
        const provider = new firebase.auth.GoogleAuthProvider()

        provider.addScope('profile')
        provider.addScope('email')

        this.$store.dispatch('userSignInWithProvider', provider)
      },
      userSignInWithFacebook ()
      {
        const provider = new firebase.auth.FacebookAuthProvider()
//      provider.addScope('profile')
        provider.addScope('email')
        this.$store.dispatch('userSignInWithProvider', provider)
      },
      test ()
      {
        console.log('Mounted store trips ' + this.trips)

        fb.tripsCollection.get().then(docs => {
          this.$vs.notify({title: 'Trips loaded', text: this.trips.length + ' trips found'})

          docs.forEach(doc => {
            console.log(doc.data())
          })
        }).catch(err => {
          console.log(err)
        })
      },
      migration1 ()
      {

        console.log('Mounted store trips ' + this.trips)

        fb.mediasCollection.get().then(docs => {

          docs.forEach(doc => {

            var key = doc.id

            fb.mediasCollection.doc(key).update({
              'signedURLs': firebase.firestore.FieldValue.delete()
            }).then(() => {
              console.log('removed !')
            })

          })
        }).catch(err => {
          console.log(err)
        })
      },
      migration2 ()
      {

      },
      migration3 ()
      {

      },

    },
    computed: {
      currentUser()
      {
        return this.$store.getters.currentUser
      },

      selectedTrip()
      {
        return this.$store.getters.selectedTrip
      },

      isAuthenticated ()
      {
        return this.$store.getters.isAuthenticated
      },
      error ()
      {
        return this.$store.state.error
      },
      loading ()
      {
        return this.$store.state.loading
      }
    },
    watch:    {
      error (value)
      {
        if (value)
        {
          this.alert = true
        }
      },
      alert (value)
      {
        if (!value)
        {
          this.$store.commit('setError', null)
        }
      }
    }
  }
</script>